import * as actions from './actions'
import {Map, fromJS, List} from 'immutable';


function reducer(
        state=Map({
            fetching: false,
            fetched: false,
            items: List()
        }),action) {
    switch (action.type) {

        case actions.AUTOMESSAGE_CREATE_REQUEST:
        case actions.AUTOMESSAGE_READ_REQUEST:
        case actions.AUTOMESSAGE_UPDATE_REQUEST:
        case actions.AUTOMESSAGE_DELETE_REQUEST:
            return state.set('fetching', true)

        case actions.AUTOMESSAGE_READ_SUCCESS:
        case actions.AUTOMESSAGE_CREATE_SUCCESS:
        case actions.AUTOMESSAGE_UPDATE_SUCCESS:
        case actions.AUTOMESSAGE_DELETE_SUCCESS:
            let automessages = action.automessages
            let result = automessages.reduce((map, obj) => {
                map[obj.id] = fromJS(obj);
                return map;
            }, {})
            return state
                    .set('fetching', false)
                    .set('fetched', false)
                    .set('items', Map(result))

        case actions.AUTOMESSAGE_UPDATE_FAILURE:
        case actions.AUTOMESSAGE_CREATE_FAILURE:
        case actions.AUTOMESSAGE_READ_FAILURE:
        case actions.AUTOMESSAGE_DELETE_FAILURE:
            return state.set('isFetching', false)
        default:
            return state
      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/AutoMessage/reducer.js